import { Skeleton, Stack } from '@mui/material';
import Typography from '../../../../components/Typography';
import PollListSkeleton from './PollList/Skeleton';

const PollsSkeleton = () => {
  return (
    <Stack gap={2}>
      <Typography variant="paragraphBold" px={2} pb={1} position="sticky" top={0} zIndex={1} bgcolor="white">
        <Skeleton variant="text" width={250} />
      </Typography>
      <PollListSkeleton />
    </Stack>
  );
};

export default PollsSkeleton;
